import { render, staticRenderFns } from "./VuesticTagGroup.vue?vue&type=template&id=fb25c302&"
import script from "./VuesticTagGroup.vue?vue&type=script&lang=js&"
export * from "./VuesticTagGroup.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTagGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticTagGroup.vue"
export default component.exports